<h2 class="default-dialog-header font-weight-normal" mat-dialog-title>
	<span fxFlex>Configure Volume Allocation</span>
	<span fxFlex="10" fxLayoutAlign="end end">
		<mat-icon (click)="onClose()" class="primary-light-color cursor-pointer">
			close
		</mat-icon>
	</span>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="default-dialog-content">
	<div class="m-t-1 m-b-1">
		<p class="font-size-14">
			Would you like to configure volume-based allocation for
			<strong>{{ carrierBusinessName }}</strong>?
		</p>

		<div *ngIf="hasExistingAllocation" class="m-t-1 existing-allocation-info">
			<mat-icon class="primary-light-color vertical-align-middle">info</mat-icon>
			<span class="font-size-13 m-l-0-5">
				Current allocation: <strong>{{ existingAllocationSummary }}</strong>
			</span>
		</div>

		<p class="font-size-13 label-text-light m-t-1">
			Volume allocation guarantees this carrier a specific percentage or number of loads
			before the waterfall bidding process begins. They will have a window to accept
			allocated loads before other carriers in the waterfall are notified.
		</p>
	</div>
</mat-dialog-content>

<mat-dialog-actions class="default-dialog-action">
	<div fxFlex fxLayoutAlign="end end" fxLayoutGap="0.5rem">
		<button (click)="onSkip()" mat-stroked-button color="primary">
			Skip Allocation
		</button>
		<button (click)="onConfigure()" mat-raised-button color="primary">
			{{ hasExistingAllocation ? 'Update Allocation' : 'Configure Allocation' }}
		</button>
	</div>
</mat-dialog-actions>
